(function () {
  var moved = false;

  function root() {
    return document.getElementById('cant-find-quote-form');
  }

  function ensureOnBody(el) {
    if (!el || moved) return;
    if (el.parentElement !== document.body) {
      document.body.appendChild(el);
    }
    moved = true;
  }

  function loadIframe(el) {
    var iframe = el.querySelector('iframe[data-src]');
    if (!iframe) return;
    var src = iframe.getAttribute('data-src');
    if (!src || iframe.getAttribute('src') === src) return;
    iframe.setAttribute('src', src);
  }

  function openQuote(event) {
    if (event) event.preventDefault();
    var el = root();
    if (!el) return;

    ensureOnBody(el);
    el.hidden = false;
    el.setAttribute('aria-hidden', 'false');
    el.classList.add('is-open');
    document.body.classList.add('cant-find-quote-open');
    loadIframe(el);

    var closeBtn = el.querySelector('[data-cant-find-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeQuote(event) {
    if (event) event.preventDefault();
    var el = root();
    if (!el || !el.classList.contains('cant-find-quote--modal')) return;

    el.classList.remove('is-open');
    el.hidden = true;
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cant-find-quote-open');
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-cant-find-open]');
    if (openBtn) {
      openQuote(event);
      return;
    }
    if (event.target.closest('[data-cant-find-close]')) {
      closeQuote(event);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeQuote();
  });
})();
